import { DONE, IGNORED, OPEN } from '../../constants/status'
import { useChangeStatusNonCompliance } from '../../../modules/nonComplianceV2/_actions/_requests/changeStatus'
import {
  useOpenEditActionPlanModal,
  useOpenNonComplianceBulkEditModal,
  useOpenNonComplianceModal
} from '../../routes/modals/modalsActions'
import { useSaveActionPlan } from '../../../modules/nonComplianceV2/_actions/_requests/saveActionPlan'
import { useSessionPermission } from '@btime/react-session'

export const useNonComplianceDetailsAction = item => {
  const openNonComplianceModal = useOpenNonComplianceModal()

  return {
    click: () => openNonComplianceModal(item)
  }
}

export const useNonComplianceCompleteAction = item => {
  const canCompleteNonCompliance = useSessionPermission('completeNonCompliance')
  const [changeStatus, { loading: loadingChangeStatus }] = useChangeStatusNonCompliance()
  const status = item?.status

  return {
    click: () => changeStatus([item.id], 'done'),
    hasPermission: [IGNORED, OPEN].includes(status) && canCompleteNonCompliance
  }
}

export const useNonComplianceReopenAction = item => {
  const canReopenNonCompliance = useSessionPermission('reopenNonCompliance')
  const status = item?.status
  const [changeStatus, { loading: loadingChangeStatus }] = useChangeStatusNonCompliance()

  return {
    click: () => changeStatus([item.id], 'open'),
    hasPermission: [IGNORED, DONE].includes(status) && canReopenNonCompliance
  }
}

export const useNonComplianceCreateActionPlanAction = item => {
  const status = item?.status
  const openActionPlanCreateModal = useOpenEditActionPlanModal()
  const [saveActionPlan] = useSaveActionPlan()

  return {
    hasPermission: [OPEN].includes(status),
    click: () =>
      openActionPlanCreateModal({
        nonComplianceId: item.id,
        placeId: item?.place?.id,
        onSubmit: saveActionPlan
      })
  }
}

export const useOpenNonComplianceBulkEdit = items => {
  const openNonComplianceBulkEditModal = useOpenNonComplianceBulkEditModal(items)

  return {
    click: () => openNonComplianceBulkEditModal(items)
  }
}
